<template>
    <div class="contact">
        <YYTitle :yyMsg="yyMessage" class="hidden-xs-only" style="margin-bottom: 20px;"></YYTitle>
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>

        <!-- 高德地图容器，复用原样式类名 -->
        <div id="amapContainer" class="bm-view mt-50"></div>

        <el-row :gutter="10" class="detail" type="flex">
            <el-col :md="24" :lg="9">
                <div class="left">
                    <div class="info" v-for="(item) in contactUs" :key="item.index">
                        <div class="icon hidden-sm-and-up">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="word">
                            <h6>{{item.name}}</h6>
                            <a :href="item.href">{{item.txt}}</a>
                        </div>
                        
                    </div>
                </div>
            </el-col>
            <XSTitle :main="board" :sub="boardEN" class="hidden-sm-and-up xsTit"></XSTitle>
            <el-col :md="24" :lg="15">
                <div class="right">
                    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
                        <el-row :gutter="20" type="flex">
                            <el-col :sm="24" :md="8">
                                <el-form-item label="姓名：" prop="name" class="textItem" >
                                    <el-input type="text" v-model="ruleForm.name" clearable></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :sm="24" :md="8">
                                <el-form-item label="邮箱：" prop="email" class="textItem" >
                                    <el-input type="text" v-model="ruleForm.email" clearable></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :sm="24" :md="8">
                                <el-form-item label="电话：" prop="phone" class="textItem" >
                                    <el-input type="text" v-model="ruleForm.phone" clearable></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row class="mt-40">
                            <el-form-item :label="wWidth<768?xsBorad:board+'：'" prop="msg">
                                <el-input type="textarea" v-model="ruleForm.msg" clearable :rows="4"></el-input>
                            </el-form-item>
                        </el-row>

                        <el-form-item class="mt-30">
                            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isDis">提交</el-button>
                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                            
                    </el-form>
                    

                </div>
            </el-col>
        </el-row>

        <div class="eyModal" v-show="ifAlert">
            <div class="mask"></div>
            <div class="modal">
                <div class="tuoyuan">
                    <div class="imgLimit"><img :src="require('@/assets/modal.png')" alt=""></div>
                    <h3>提交成功</h3>
                </div>
                
                <button @click="close">关闭</button>
            </div>
        </div>
    </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'
import NewsApi from '@/api/newsApi.js'
// 高德地图加载器
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
    components:{
        YYTitle,
        XSTitle
    },
    data(){
        var checkName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('用户名不能为空'));
            }else{
                callback()
            }
        }
        var checkEmail = (rule, value, callback) => {
            let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/

            if (!value) {
                callback(new Error('邮箱不能为空'))
            }

            setTimeout(() => {
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的邮箱格式'))
                }
            }, 100)
        }
        var checkPhone = (rule, value, callback) => {
            let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/

            if (!value) {
                callback(new Error('电话不能为空'))
            }

            setTimeout(() => {
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号'))
                }
            }, 100)
        }
        return{
            yyMessage:"联系我们",
            titEN: 'CONTACT US',
            board: '留言',
            boardEN: 'MESSAGE BOARD',
            xsBorad:'需求 or 洽谈：',
            latitude: '',
            longitude: '',
            map:{
                // 医影智能产业园 高德原生标准坐标，位置精准无偏移
                center: {lng: 121.397177, lat: 37.413708},
                zoom: 16,
                scroll: true
            },
            mapInstance: null, // 高德地图实例
            initLat: '',
            initLng: '',
            partnerAddress:"山东医影智能科技有限公司",
            contactUs:[{name: '商务合作',txt: 'in_eying@163.com', href: 'mailto:in_eying@163.com',icon: require('@/assets/phone/CO1.png')},
                        {name: '联系电话',txt: '0535-3931271', href: 'tel:0535-3931271',icon: require('@/assets/phone/CO2.png')},
                        {name: '公司地址',txt: '山东·烟台·医影智能', href: 'javascript:;',icon: require('@/assets/phone/CO3.png')}],
            ruleForm:{
                name:'',
                email:'',
                phone:'',
                msg:''
            },
            rules:{
                name:[{validator: checkName, trigger: 'blur'}],
                email:[{validator: checkEmail, trigger: 'blur'}],
                phone:[{validator: checkPhone, trigger: 'blur'}],
            },
            ifAlert:false,
            isDis: false,
            wWidth: window.screen.width
        }
    },
    created(){
        
    },
    mounted(){
        // 初始化高德地图
        this.initMap()
    },
    methods:{
        // 高德地图初始化：永久固定公司位置，定位不跳转地图视野
        initMap () {
            let self = this
            AMapLoader.load({
                key: 'd330aa1201f98398cf45756042589b55',
                version: '2.0',
                plugins: ['AMap.Geolocation']
            }).then((AMap) => {
                // 1. 创建地图实例，中心点永久绑定公司坐标
                const map = new AMap.Map('amapContainer', {
                    center: [self.map.center.lng, self.map.center.lat],
                    zoom: self.map.zoom,
                    scrollWheel: self.map.scroll
                })
                self.mapInstance = map

                // 2. 公司标记点 + 弹跳动画 + 点击触发导航
                const marker = new AMap.Marker({
                    position: [self.map.center.lng, self.map.center.lat],
                    animation: 'AMAP_ANIMATION_BOUNCE',
                    cursor: 'pointer'
                })
                map.add(marker)
                marker.on('click', () => {
                    self.guide()
                })

                // 3. 公司文字标签 + 点击触发导航
                const label = new AMap.Text({
                    text: '医影智能',
                    position: [self.map.center.lng, self.map.center.lat],
                    offset: new AMap.Pixel(-32, 18),
                    cursor: 'pointer',
                    style: {
                        padding: '10px 15px',
                        color: '#2563AF',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        border: 'none',
                        background: 'white',
                        borderRadius: '8px',
                        marginTop: '10px'
                    }
                })
                map.add(label)
                label.on('click', () => {
                    self.guide()
                })

                // 4. 右上角定位控件：仅获取用户坐标，不改变地图中心点
                const geolocation = new AMap.Geolocation({
                    position: 'RB',
                    showCircle: false,  //关闭蓝色定位精度圈
                    showMarker: false,  // 关闭用户当前位置标记点
                    zoomToAccuracy: false, // 定位成功后不自动平移、缩放地图
                    noIpLocate: true
                })
                map.addControl(geolocation)

                // 定位成功：保存用户坐标并发起导航，地图画面保持不动
                geolocation.on('complete', function(e){
                    self.initLng = e.position.lng
                    self.initLat = e.position.lat
                    self.guide()
                })

                // 定位失败回调
                geolocation.on('error', function(e){
                    alert(e.message)
                })
            }).catch((e) => {
                console.error('高德地图加载失败：', e)
            })
        },

        // 导航逻辑：兼容安卓/iOS/PC，有无定位均可正常跳转
        guide() {
            let self = this
            let lat = this.map.center.lat
            let lng = this.map.center.lng
            const destName = encodeURIComponent(self.partnerAddress)

            // 安卓端：优先调起高德APP，失败降级网页版
            if (self.customBrowserVersion().android) {
                let d = new Date();
                let t0 = d.getTime();
                window.location.href = `androidamap://viewMap?sourceApplication=appname&poiname=${destName}&lat=${lat}&lon=${lng}&dev=0`;
                
                var delay = setInterval(function () {
                    var d = new Date();
                    var t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                        window.location.href = `https://uri.amap.com/marker?position=${lng},${lat}&name=${destName}&src=eying-website`;
                    }
                    if (t1 - t0 >= 3000) {
                        clearInterval(delay);
                    }
                }, 1000);
            }

            // iOS端：优先调起高德APP，失败降级网页版
            if (self.customBrowserVersion().ios) {
                let d = new Date();
                let t0 = d.getTime();
                window.location.href = `iosamap://viewMap?sourceApplication=appname&poiname=${destName}&lat=${lat}&lon=${lng}&dev=0`;
                
                let delay = setInterval(function () {
                    var d = new Date();
                    var t1 = d.getTime();
                    if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                        window.location.href = `https://uri.amap.com/marker?position=${lng},${lat}&name=${destName}&src=eying-website`;
                    }
                    if (t1 - t0 >= 3000) {
                        clearInterval(delay);
                    }
                }, 1000);
            }

            // PC端：有定位直接规划路线，无定位打开目的地详情页
            if (!self.customBrowserVersion().mobile) {
                if (self.initLng && self.initLat) {
                    const href = `https://uri.amap.com/navigation?from=${self.initLng},${self.initLat},我的位置&to=${lng},${lat},${destName}&mode=car&src=eying-website`;
                    window.open(href);
                } else {
                    const href = `https://uri.amap.com/marker?position=${lng},${lat}&name=${destName}&src=eying-website`;
                    window.open(href);
                }
            }
        },

        // 设备判断方法 原样保留
        customBrowserVersion() {
            var u = navigator.userAgent;
            return {
                trident: u.indexOf('Trident') > -1,
                presto: u.indexOf('Presto') > -1,
                webKit: u.indexOf('AppleWebKit') > -1,
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
                mobile: !!u.match(/AppleWebKit.*Mobile.*/),
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
                iPhone: u.indexOf('iPhone') > -1,
                iPad: u.indexOf('iPad') > -1,
                webApp: u.indexOf('Safari') == -1,
                weixin: u.indexOf('MicroMessenger') > -1,
                qq: u.match(/\sQQ/i) == " qq",
                isBaidu: u.indexOf('baiduboxapp') !== -1,
                isqqBrowser: u.indexOf('mqqbrowser') !== -1,
                isWxBrowser: u.indexOf('micromessenger') !== -1,
                isUc: u.indexOf('ucbrowser') !== -1,
            };
        },
        
        // 提交留言接口 原样保留
        post_newsList(){
            NewsApi.postUs(this.ruleForm.email,this.ruleForm.msg,this.ruleForm.phone,this.ruleForm.name).then((res)=>{
                if(res.data.code == 0){
                    this.ifAlert = true     
                }else{
                    alert(res.data.code)
                }
            })
        },

        // 表单提交 原样保留
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.post_newsList()
                    this.isDis = true
                    setTimeout(()=>{
                        this.isDis = false
                    },3000)
                } else {
                    return false;
                }
            });
        },
        // 表单重置 原样保留
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 关闭弹窗 原样保留
        close(){
            this.ifAlert = false
            this.resetForm('ruleForm')
        }
    }
    
}
</script>

<style lang="scss" scoped>
/* 所有样式完全保留，未做任何修改 */
.contact{
    padding: vw(67) vw(360) vw(56);

    .bm-view {
        width: vw(1200);
        height: vw(464);
        margin: auto;
    }

    .detail{
        margin-top: vw(70);
        flex-wrap: wrap;
        align-items: center;

        .left{
            display: flex;
            flex-direction: column;
            position: relative;
            padding: vw(52) vw(51) vw(39) vw(106);
            background: rgba(146,208,252,.1);
            border-radius: 0 vw(60) 0 0;

            .info{
                width: vw(292);
                white-space: nowrap;

                h6,a{
                    margin: 0;
                    text-align: left;
                    font-weight: 500;
                    color: $yyBlue;
                }

                h6{
                    font-size: vw(16);
                    padding-bottom: vw(18);
                    padding-top: vw(60);
                }

                a{
                    font-size: vw(24);
                    display: block;
                }

                &:first-of-type{
                    h6{
                        padding-top: 0;
                    }
                }

                &:last-of-type{
                    a{
                        cursor: default;
                    }
                }
            }

            &::before{
                content: "CONTACT US";
                font-size: vw(53);
                position: absolute;
                width: 21.54167vw;
                top: 9.2vw;
                left: -9.26vw;
                color: white;
                background: $yyBlue;
                white-space: nowrap;
                transform: rotate(-90deg);
            }

        }

        .right{
            padding-top: vw(10);
            margin-left: vw(40);

            .textItem{
                min-width: vw(220);
            }

            .areaItem{
                max-width: vw(680);
            }

            ::v-deep {
                .el-row{
                    flex-wrap: wrap;
                }

                .el-form-item{
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 0;
                }

                .el-form-item__label{
                    font-size: vw(16);
                    text-align: left;
                    white-space: nowrap;
                }

                .el-input{
                    min-width: vw(184);
                }

                .el-button{
                    font-size: vw(16);
                    padding: .875rem 1.375rem;
                }

                .el-button:focus, .el-button:hover {
                    color: $yyBlue;
                }

                .el-button--primary{
                    background: $yyBlue;
                    border-color: $yyBlue;

                    &:hover,&:focus{
                        color: white;
                    }
                }

            }
        }
    }

    .eyModal{
        width: 100%;
        height: 100%;
        position: fixed;
        float: left;
        top: 0;
        left: 0;
        z-index: 110;

        .mask{
            width: 100%;
            height: 100%;
            background: rgba(150, 167, 190, 0.6);
            position: fixed;
            float: left;
            left: 0;
            top: 0;
            z-index: 111;
        }
        .modal{
            position: relative;
            width: vw(460);
            left: 40%;
            top: 30%;
            z-index: 150;
            background: white;
            border-radius: 10px;

            .tuoyuan{
                position: absolute;
                top: 0;
                height: vw(173);
                width: vw(460);
                background: linear-gradient(117deg, #2563AF, #7199FF);
                border-radius: 50% / 0 0 100% 100%;

                .imgLimit{
                    width: vw(422);
                    height: vw(173);
                    margin: 0 auto;

                    img{
                        width: 100%;
                        height: 100%;
                    }
                }

                h3{
                    position: absolute;
                    top: vw(69);
                    left: vw(150);
                    font-size: vw(36);
                    margin: 0;
                    color: $grayFD;
                    text-shadow: 0px 9px 10px rgba(113, 103, 247, 0.48);
                }
            }

            button{
                font-size: vw(16);
                padding: vw(16) vw(120);
                margin: vw(209) vw(20) vw(45);
                color: white;
                background: linear-gradient(180deg, rgba(37,99,175,.8), $yyBlue);
                border: 0;
                outline: 0;
                border-radius: 23px;

                &:hover{
                    cursor: pointer;
                }
            }
        }
    }

    ::v-deep {
        .cusTitle{
            font-size: vw(30);
            color: $font18;
            font-weight: 800;
            
            &:after{
                content: 'CONTACT US';
                color: $lightBlue;
                font-size: vw(48);
                top: vw(-4);
                left: vw(430);
                font-weight: bold;
                opacity: 0.3;
                z-index: -1;
            }
        }
    }

    // 手机端适配
    @media only screen and (max-width: 767px){
        padding-top: vp(50);

        .bm-view{
            width: 100%;
            height: vp(388);
        }

        .detail{
            margin-top: vp(42);

            .left{
                padding: vp(50);
                &::before{
                    display: none;
                }

                .info{
                    width: auto;
                    display: flex;
                    align-items: center;
                    white-space: normal;

                    .icon{
                        width: vp(40);
                        height: vp(40);
                        margin-right: vp(32);

                        
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }

                    &:last-of-type{
                        .icon{
                            width: vp(35);
                            height: vp(43);
                        }
                    }

                    h6,
                    a{
                        color: $font33;
                    }

                    h6{
                        font-size: vp(24);
                        padding-top: vp(35);
                        padding-bottom: vp(15);
                    }

                    a{
                        font-size: vp(36);
                        font-weight: 600;
                    }
                }
            }

            ::v-deep {
                .xsTit{
                    margin-top: vp(50);
                    padding-left: vp(230);
                }
            }

            .right{
                ::v-deep {
                    .el-form-item__label{
                        font-size: vp(30);
                    }

                    .el-form-item{
                        margin-bottom: vp(40);
                        button{
                            margin-bottom: vp(40);
                        }
                        
                    }

                    .el-button{
                        font-size: vp(36);
                    }

                }
            }
        }

        .eyModal{
            .modal{
                width: vp(576);
                left: 11.6%;
                top: 23.7%;

                .tuoyuan{
                    width: vp(576);
                    height: vp(214);

                    .imgLimit{
                        width: vp(520);
                        height: vp(214);
                    }

                    h3{
                        top: vp(90);
                        left: vp(220);
                        font-size: vp(36);
                    }
                }

                button{
                    font-size: vp(32);
                    padding: vp(22) vp(140);
                    margin: vp(260) vp(100) vp(58);
                    border-radius: vp(37);
                }
            }
        }
    }
}
</style>